<template>
  <el-dialog v-bind="$attrs" class="base-dialog" :class="{ 'is-form-dialog': isForm }"
             :close-on-click-modal="false" :width="width" :visible.sync="dialogVisible"
             :show-close="showClose" :before-close="handleClose" @closed="handleClosed"
             @open="handleOpen">
    <div slot="title" class="el-dialog__title">
      <slot name="title">提示</slot>
    </div>
    <slot></slot>
    <div slot="footer" v-show="showButton">
      <el-button size="small" @click="handleClose" v-show="showCloseButton" class="primary-button">
        <slot name="close">取消</slot>
      </el-button>
      <el-button size="small" type="primary" v-show="showConfirmButton" @click="handleConfirm">
        <slot name="confirm">确认</slot>
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'Dialog',
  props: {
    isForm: {
      type: Boolean,
      default () {
        return false;
      }
    },
    dialogVisible: {
      type: Boolean,
      require: true
    },
    width: {
      type: String,
      default () {
        return '480px'
      }
    },
    showClose: {
      type: Boolean,
      default () {
        return true;
      }
    },
    showButton: {
      type: Boolean,
      default () {
        return true
      }
    },
    showConfirmButton: {
      type: Boolean,
      default () {
        return true
      }
    },
    showCloseButton: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  methods: {
    handleClose () {
      this.$emit('handleClose')
    },
    handleConfirm: _.throttle(async function () {
      this.$emit('handleConfirm')
    }, 1500, {
      leading: true,
      trailing: false
    }),
    handleClosed () {
      this.$emit('handleClosed')
    },
    handleOpen () {
      this.$emit('handleOpen')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./assets/style.scss";
</style>
